<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/pajamas/remove";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.InputIcon v-tooltip.left="'Hapus'">
        <Icon class="text-gray-500 hover:text-red-500 hover:cursor-pointer" @click="$emit('click')" />
    </PV.InputIcon>
</template>
